
import Vue from "vue";
import { data } from "@/model/Data";

export default Vue.extend({
    data: () => ({
        data,
        recalled: [{value: ""}]
    }),

    mounted() {
        this.recalled = [];
        for (var {} of this.data.words) 
            this.recalled.push({value: ""});
    },

    methods: {
        click() {
            var indices: Set<number> = new Set<number>();
            for (var data of this.recalled)
                indices.add(this.data.words.indexOf(data.value.toLowerCase()));

            // One point per correct word, -1 is incorrect so must remove
            this.data.scores["Recall Test"] = indices.size - (indices.has(-1) ? 1 : 0);

            // Convert to percentage
            this.data.scores["Recall Test"] = this.data.scores["Recall Test"] * 100 / this.data.words.length;

            this.$emit("complete", "CVFT");
        }
    }
});

